const ns = "ACCOUNTS_VALUE";
export const CREATE = `${ns}_CREATE`;
export const BULK_CREATE = `${ns}_BULK_CREATE`;
